import {
    ShoppingCart,
} from "lucide-react";

function CartHeader({
    count = 0,
}) {

    return (

        <div style={styles.header}>

            <div style={styles.iconBox}>

                <ShoppingCart
                    size={34}
                    color="#00ff88"
                />

            </div>

            <div>

                <h1 style={styles.title}>

                    Your Cart

                </h1>

                <p style={styles.subtitle}>

                    {count === 0 ? (

                        "Your cart is currently empty"

                    ) : (

                        <>
                            <span style={styles.count}>
                                {count}
                            </span>

                            {" "}

                            item
                            {count !== 1 ? "s" : ""}

                            {" "}

                            in cart
                        </>
                    )}

                </p>

            </div>

        </div>
    );
}

const styles = {

    header: {

        display:
            "flex",

        alignItems:
            "center",

        gap:
            "16px",

        marginBottom:
            "30px",
    },

    iconBox: {

        display: "flex",

        alignItems: "center",

        gap: "14px",

        color: "#fff",

        fontSize: "40px",

        fontWeight: "800",

        marginBottom: "10px",
    },

    title: {

        margin:
            0,

        color:
            "#ffffff",

        fontSize:
            "38px",

        fontWeight:
            "800",

        lineHeight:
            "42px",
    },

    subtitle: {

        margin:
            "6px 0 0 0",

        color:
            "#cbd5e1",

        fontSize:
            "15px",
    },

    count: {

        color:
            "#00ff88",

        fontWeight:
            "800",
    },
};

export default CartHeader;